import Vue      from 'vue'
import Vuex     from 'vuex'
import axios    from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        logget: false,
        address: null,
        inbox: false,
        message: {
            count: 0
        }
    },
    mutations: {
        setInboxBadge(state, payload) {
            state.inbox = payload;
        },
        setMessageCount(state, payload) {
            state.message.count = payload.count;
        },
        setLocalStorage(state, payload) {
            localStorage.setItem(payload.name, payload.value);
        },
        clearLocalStorage(state, payload) {
            localStorage.removeItem(payload);
        }
    },
    actions: {
        logout() {

            // Clear local storage.
            this.commit('clearLocalStorage', 'token');
            this.commit('clearLocalStorage', 'account');
            this.state.logget = false;

            delete axios.defaults.headers.common.Authorization;
        },
        getLocalStorage(state, payload) {
            return localStorage.getItem(payload);
        },
        getLocalStorageObject(state, payload) {
            return JSON.parse(localStorage.getItem(payload));
        },
        getMessageCount() {
            return this.state.message.count;
        }
    },
    getters: {
        logget(state) {
            return state.logget !== false;
        }
    },
})
